<template>
  <b-modal
    id="modal-event-attendance"
    dialog-class="base-modal omz-attend"
    body-class="p-0"
    hide-header
    hide-header-close
    hide-footer
    centered
  >
    <div class="title">{{ texts.title }}</div>
    <div class="omz-modal-content">
      <div v-html="texts.content"></div>
    </div>

    <div class="attend-table-wrapper">
      <img class="omz-coin" :src="`${$s3}/img/common/event/omz_attendance/coin.webp?${$ver}`" />
      <div class="attend-table">
        <header>
          <div class="attend-title">{{ texts.attend.title }}</div>
          <div class="usr-attend">{{ texts.attend.usrAttend(usrAttend) }}</div>
        </header>
        <div class="attend">
          <OmzAttendance :usrAttend="usrAttend" :type="'modal'" />
        </div>
      </div>
    </div>

    <div class="btn-wrapper">
      <button class="modal-btn confirm" id="modal-confirm-btn" @click="$bvModal.hide('modal-event-attendance')">
        {{ $t('modal.confirm') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import OmzAttendance from '@/views/Events/OMZAttendance.vue';
import { mapState } from 'vuex';

const texts = {
  ko: {
    title: 'OMZ 발행 기념 이벤트',
    content:
      '09.04 ~ 09.11 까지 특별 출석이벤트를 진행합니다.<br /><span>최소 7일을 출석해야 모든 보상을</span> 받을 수 있습니다.',
    attend: {
      title: '당첨 출석체크',
      usrAttend: (attend) => `나의 출석횟수 ${attend}회`,
    },
  },
  // translate to english
  en: {
    title: 'OMZ Publishing Event',
    content: 'Special attendance event: 09/04 - 09/11.<br />You must <span>attend 7 days for full rewards.</span>',
    attend: {
      title: 'Attendance Check',
      usrAttend: (attend) => `My attendance ${attend} times`,
    },
  },
};

export default {
  name: 'OmzAttendanceModal',
  components: {
    OmzAttendance,
  },
  props: ['usrAttend'],
  computed: {
    ...mapState(['lang']),
    texts() {
      return texts[this.lang];
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.modal-dialog.base-modal.omz-attend {
  max-width: 641px;
  margin: 0 auto;
  line-height: 1.2;

  @include mobile {
    min-width: 320px;
    max-width: 95%;
  }

  .modal-content {
    background: center / contain no-repeat url($s3-url + '/img/common/event/omz_attend_bg.webp?' + $version), #ffffff;
    // // aspect-ratio: 641 / 734;
    width: 641px;
    height: calc(641px * 734 / 641);

    @include mobile {
      width: 100%;
      height: calc(95vw * 734 / 641);
    }

    .modal-body {
      display: flex;
      flex-direction: column;
      .title {
        color: #543905;
        text-align: center;
        font-size: 44px;
        font-weight: 700;
        padding-top: 41px;
        line-height: 1.2;

        @include mobile {
          font-size: 22px;
          padding-top: 16px;
        }
      }
      .omz-modal-content {
        height: 100%;
        text-align: center;
        padding: 28px;
        color: #2a2d35;
        text-align: center;
        font-size: 20px;
        font-weight: 400;

        @include mobile {
          font-size: 14px;
          padding: 0 12px;
          padding-bottom: 10px;
          display: grid;
          justify-content: center;
          align-items: center;
        }

        span {
          color: #7d5820;
          font-weight: 700;
        }
      }
      .attend-table-wrapper {
        position: relative;
        padding: 0 28px;

        @include mobile {
          padding: 0 12px;
        }

        img.omz-coin {
          position: absolute;
          right: 0;
          height: 42%;
          transform: translateY(-65%);

          @include mobile {
            height: 70px;
          }
        }

        .attend-table {
          background: #ffffff;
          border-radius: 4px;

          header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 1.2;
            padding: 20px 32px;

            @include mobile {
              padding: 8px 12px;
            }

            .attend-title {
              color: #a97025;
              font-size: 22px;
              font-weight: 600;
              letter-spacing: -0.44px;

              @include mobile {
                font-size: 14px;
              }
            }
            .usr-attend {
              color: #a8875b;
              font-size: 16px;
              font-weight: 400;

              @include mobile {
                font-size: 12px;
              }
            }
          }
          .attend {
            padding: 0 20px;
            padding-bottom: 14px;

            @include mobile {
              padding: 0 8px;
              padding-bottom: 8px;
            }
          }
        }
      }
      .btn-wrapper {
        padding-top: 25px;

        @include mobile {
          padding: 8px 12px;
        }

        button.modal-btn.confirm {
          background: #f3960a;
          height: 68px;
          font-size: 28px;

          @include mobile {
            height: 45px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
